import React, { useReducer, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from '../../functions/axios';
import style from './Register.module.css';
import MultipleSelectCheckmarks from '../componets/MultipleSelectCheckmarks';
import { useAuthContext } from '../../hooks/useAuthContext';

function AddUser() {
  const { user } = useAuthContext();
  const [cars, setCars] = useState([]);
  const formReducer = (state, event) => {
    if (event.reset) {
      return {
        userName: '',
        surName: '',
        password: '',
        email: '',
        passwordConfirm: '',
        manageUsers: false,
        manageCarriage: false,
        managePaletts: false,
        manageCarsService: false,
        manageNotes: false,
      };
    }
    return {
      ...state,
      [event.name]: event.value,
    };
  };
  const [formData, setFormData] = useReducer(formReducer, {});
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();
  const validateData = () => {
    return formData.userName && formData.surName && formData.email && formData.password.length > 8 && formData.password === formData.passwordConfirm;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    setSubmitting(true);
    if (!validateData()) return;
    await axios.post(`/registerUser`, formData);
    setTimeout(() => {
      setSubmitting(false);
    }, 3000);
    navigate('/UserList');
  };

  const handleChange = (event) => {
    const isCheckbox = event.target.type === 'checkbox';
    setFormData({
      name: event.target.name,
      value: isCheckbox ? event.target.checked : event.target.value,
    });
  };

  const ConfirmData = () =>
    validateData() ? (
      <div>
        <label>OK! Dane zostały wprowadzone</label>:
        <ul>
          <li>Nazwa użytkownika: {formData.userName}</li>
          <li>Imię i Nazwisko: {formData.surName}</li>
        </ul>
      </div>
    ) : (
      <div>
        <label>Nie poprawne dane</label>
      </div>
    );

  useEffect(() => {
    if (!user) return null;
    (async () => {
      try {
        const { data: response } = await axios.get(`/car`);
        setCars(response);
      } catch (error) {
        console.error(error.message);
      }
    })();
  }, [user]);

  if (!user) return null;

  return (
    <div className={style.wrapper}>
      <form>
        <div className={style.section}>
          <h1>Dodawanie użytkownika</h1>
          <br />
          <div className={style.category}>Dane użytkownika</div>
          <div className={style.row}>
            <label className={style.subcategory} htmlFor='userName-data'>
              Nazwa użytkownika:
            </label>
            <input id='userName-data' placeholder='nazwa użytkownika' name='userName' onChange={handleChange} value={formData.userName || ''} />
          </div>
          <div className={style.row}>
            <label className={style.subcategory} htmlFor='surName-data'>
              Imię i nazwisko:
            </label>
            <input placeholder='Imię i nazwisko' name='surName' onChange={handleChange} value={formData.surName || ''} />
          </div>
          <div className={style.row}>
            <label className={style.subcategory} htmlFor='surName-data'>
              Adres e-mail:
            </label>
            <input placeholder='podaj adres e-mail' name='email' type='email' onChange={handleChange} value={formData.email || ''} />
          </div>
          <h3>Uprawnienia:</h3>
          <div className={style.row2}>
            <label className={style.subcategory} htmlFor='manageUsers'>
              Administracja aplikacji, zarządzanie innymi użytkownikami:
            </label>
            <input id='manageUsers' type='checkbox' name='manageUsers' onChange={handleChange} value={formData.manageUsers || ''} />
          </div>

          <div className={style.row2}>
            <label className={style.subcategory} htmlFor='manageCarriage'>
              Edycja bazy transportów:
            </label>
            <input id='manageCarriage' type='checkbox' name='manageCarriage' onChange={handleChange} value={formData.manageCarriage || ''} />
          </div>

          <div className={style.row2}>
            <label className={style.subcategory} htmlFor='managePaletts'>
              Edycja bazy palet:
            </label>
            <input id='managePaletts' type='checkbox' name='managePaletts' onChange={handleChange} value={formData.managePaletts || ''} />
          </div>
          <div className={style.row2}>
            <label className={style.subcategory} htmlFor='manageInvoice'>
              Edycja faktur:
            </label>
            <input id='manageInvoice' type='checkbox' name='manageInvoice' onChange={handleChange} defaultChecked={formData.manageInvoice || ''} />
          </div>
          <div className={style.row2}>
            <label className={style.subcategory} htmlFor='manageCarsService'>
              Edycja bazy serwisu pojazdów:
            </label>
            <input id='manageCarsService' type='checkbox' name='manageCarsService' onChange={handleChange} value={formData.manageCarsService || ''} />
          </div>
          <div className={style.row2}>
            <label className={style.subcategory} htmlFor='manageNotes'>
              Edycja notatek:
            </label>
            <input id='manageNotes' type='checkbox' name='manageNotes' onChange={handleChange} defaultChecked={formData.manageNotes || ''} />
          </div>
          <div className={style.row2}>
            <label className={style.subcategory} htmlFor='manageNotes'>
              Edycja przydzielonych pojazdów:
            </label>
            <MultipleSelectCheckmarks
              data={cars}
              labelProp='plate'
              customRender={(item) => `${item.plate} (${item.brand || 'brak danych'})`}
              label='Przydzielone pojazdy:'
              value={formData.allowedCars || []}
              onChange={(value) => setFormData({ name: 'allowedCars', value })}
            />
          </div>
          <br />
          <br />
          <hr />
          <br />
          <div className={style.row}>
            <label className={style.subcategory} htmlFor='password'>
              Podaj hasło użytkownika:
            </label>
            <input
              id='password'
              minLength={8}
              placeholder='podaj hasło'
              name='password'
              type='password'
              onChange={handleChange}
              value={formData.password || ''}
            />
          </div>
          <div className={style.row}>
            <label className={style.subcategory} htmlFor='passwordConfirm'>
              Powtórz hasło:
            </label>
            <input name='passwordConfirm' placeholder='potwierdź hasło' type='password' onChange={handleChange} value={formData.passwordConfirm || ''} />
          </div>
        </div>
        <hr />
        <div className={style.buttons}>
          <button className='btn btn-default' onClick={navigate.bind(null, '../userList', { state: { date: formData.day } })}>
            Anuluj
          </button>
          <button className='btn btn-default' type='submit' onClick={handleSubmit}>
            Stwórz użytkownika
          </button>
        </div>
      </form>

      {submitting && <ConfirmData />}
    </div>
  );
}

export default AddUser;
